import { ServiceTimeClass } from '@mews/enums';
import { DividerList } from '@mews-commander/ui';
import { getTimeClass, useCommanderSelector } from '@mews-commander/utils';
import { isCurrentEnterprisePaymentAndCancellationPoliciesExceptionsEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { useCurrentRateGroupContext, useCurrentServiceIdContext } from '../../../contexts';
import { useSelectedService } from '../../forms/hooks/useSelectedService';
import { SettlementConfigurationSection } from './SettlementConfigurationSection';
import { DefaultPolicySection } from './DefaultPolicySection';
import { PolicyExceptionsSection } from './PolicyExceptionsSection';

interface PoliciesTabContentProps {
    editPaymentConfigurationButton: React.ReactNode;
    editDefaultPolicyButton: React.ReactNode;
    policyExceptionsEditable?: boolean;
}

export const PoliciesTabContent = ({
    editPaymentConfigurationButton,
    editDefaultPolicyButton,
    policyExceptionsEditable = true,
}: PoliciesTabContentProps) => {
    const { defaultPolicy, policyExceptions, isPortfolioManaged, enterpriseId, options, ...other } =
        useCurrentRateGroupContext();

    const serviceId = useCurrentServiceIdContext();
    const service = useSelectedService({ enterpriseId, serviceId });
    const serviceTimeClass = service ? getTimeClass(service) : undefined;

    const arePolicyExceptionsEnabled = useCommanderSelector(
        isCurrentEnterprisePaymentAndCancellationPoliciesExceptionsEnabled
    );

    const validOptions = options.filter((option) => option !== 'RequirePaymentCardDuringOnlineCheckIn');

    return (
        <DividerList spacing="400">
            <SettlementConfigurationSection
                {...other}
                serviceTimeClass={serviceTimeClass}
                options={validOptions}
                rightContent={isPortfolioManaged ? null : editPaymentConfigurationButton}
            />
            <DefaultPolicySection
                rightContent={isPortfolioManaged || !defaultPolicy ? null : editDefaultPolicyButton}
                defaultPolicy={defaultPolicy}
                options={options}
            />
            {(serviceTimeClass === ServiceTimeClass.Day || serviceTimeClass === ServiceTimeClass.Night) &&
            arePolicyExceptionsEnabled &&
            policyExceptions ? (
                <PolicyExceptionsSection policyExceptions={policyExceptions} editable={policyExceptionsEditable} />
            ) : null}
        </DividerList>
    );
};
